/*

|--------------------------------------------------------------------------
| consumerMarketing: aggrego
|--------------------------------------------------------------------------
*/
/**
 * @namespace 
 */
__gh__webApp.consumerMarketing.aggrego = {

	"loadLibrary": function(){
		var src;
		//change html_anchor_id based on device because div showing in different location
		if(__gh__webApp.device.isPhone()){
			src = '//headlinesnetwork.com/embed_widget.js?tag=0bd438e69d954a043ba7ba0c7915b5db&html_anchor_id=exchange-embed-widget-0bd44';
		}
		else{
			src = '//headlinesnetwork.com/embed_widget.js?tag=0bd438e69d954a043ba7ba0c7915b5db&html_anchor_id=exchange-embed-widget-0bd43';
		}
		__gh__webApp.common.loadScript({
			"src": src
		});
		debug.log("consumerMarketing.aggrego.loadLibrary")
	}

};